import React from 'react';
import { Spin, Transfer } from 'antd';
import { connect } from 'react-redux';

import { serviceListLoad } from "store/api/service";
import { FormItem } from "utils";
import { DataLoadComponent } from 'components/common';


class ServiceTransferField extends DataLoadComponent {
  apiListLoad = serviceListLoad;

  render() {
    const { form, instance, name, label, required, errorData, initialValue } = this.props;
    const { items, loadStatus } = this.state;

    const dataSource = items.map(item => {
      item.key = item.id;
      return item;
    });

    return (
      <Spin spinning={loadStatus.isLoading}>
        <FormItem
          form={form}
          instance={instance}
          name={name}
          label={label}
          required={required}
          errorData={errorData}
          initialValue={initialValue}
          valuePropName='targetKeys'
        >
          <Transfer
            dataSource={dataSource}
            showSearch
            listStyle={{
              width: 250,
              height: 300,
            }}
            operations={['to right', 'to left']}
            render={item => `${item.name}`}
          />
        </FormItem>
      </Spin>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_token: state.auth.token,
  };
}

export default connect(mapStateToProps)(ServiceTransferField);
